// Maps the work duration objects with start and end times
class WorkDuration {
    constructor({ id,startTime, endTime }) {
      // Convert the ISO string dates into JavaScript Date objects
      this.id=id;
      this.startTime = new Date(startTime);
      this.endTime = new Date(endTime);
    }
  }
  
  // Maps the plan for a particular day including day status and work durations
  class Plan {
    constructor({ id, dayStatus, workDurations }) {
      this.id = id;
      this.dayStatus = dayStatus;
      // Map each work duration to an instance of WorkDuration
      this.workDurations = (workDurations || []).map(wd => new WorkDuration(wd));
    }
  }
  
  // Maps the daily plan which includes the day name and its associated plan
  class DailyPlan {
    constructor({ id, day, plan, subOrganisationId, subOrganisation }) {
      this.id = id;
      this.day = day;
      // Create a new Plan instance from the nested plan object
      this.plan = new Plan(plan);
      // Include SubOrganisation properties
      this.subOrganisationId = subOrganisationId;
      this.subOrganisation = subOrganisation;
    }
  }
  
  // Maps the week plan which contains an array of daily plans
  class WeekPlan {
    constructor({ dailyPlans }) {
      // Map each daily plan to a DailyPlan instance
      this.dailyPlans = (dailyPlans || []).map(dp => new DailyPlan(dp));
    }
  }
  
  // Maps the calendar template which includes the year, week plan, and work time details
  class CalendarTemplate {
    constructor({
      id, year, weekPlan, workTimeHours, workTimeMinutes,
      // Epic 26/27: per-template management fields.
      name, isActive, validFrom, validTo, isDefault, isArchived, createdAt,
    }) {
      this.id = id;
      // Although the property is called 'year', the value is a full date string
      this.year = new Date(year);
      // Create a new WeekPlan instance from the weekPlan object
      this.weekPlan = new WeekPlan(weekPlan);
      this.workTimeHours = workTimeHours;
      this.workTimeMinutes = workTimeMinutes;
      // Management fields. name/status/default/archived are plain values.
      this.name = name ?? null;
      this.isActive = isActive ?? false;
      this.isDefault = isDefault ?? false;
      this.isArchived = isArchived ?? false;
      // Date-only validity + creation timestamp. Kept as the raw backend strings
      // (e.g. "2026-01-31") — NOT wrapped in `new Date(...)` so they never pass
      // through the shift-time UTC↔local conversion used for WorkDuration. The
      // renderer parses them with `dayjs(...)` at day granularity.
      this.validFrom = validFrom ?? null;
      this.validTo = validTo ?? null;
      this.createdAt = createdAt ?? null;
    }
  }
  
  // Maps the top-level user calendar object which includes user details and calendar templates
  class UserCalendar {
    constructor({ id, organizationId, userId, name, calendarTemplates, email }) {
      this.id = id;
      this.organizationId = organizationId;
      this.userId = userId;
      this.name = name;
      this.email = email;
      // Map each calendar template to a CalendarTemplate instance
      this.calendarTemplates = (calendarTemplates || []).map(ct => new CalendarTemplate(ct));
    }
  }

  export default UserCalendar;
  


